// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import RobotOutlinedSvg from "@fishx/icons-svg/es/asn/RobotOutlined";
import FishxIcon from '../components/FishxIcon';

var RobotOutlined = function RobotOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: RobotOutlinedSvg
  }));
};

RobotOutlined.displayName = 'RobotOutlined';
export default React.forwardRef(RobotOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/RobotOutlined.js
// module id = 4027
// module chunks = 0